import { createFileRoute } from '@tanstack/react-router'
import { ReportsPage } from '@/features/reports/ui/reports-page'
import { PageLayout } from '@/components/page-layout'

export const Route = createFileRoute('/_authenticated/reports')({
	component: ReportsRoute,
})

function ReportsRoute() {
	return (
		<PageLayout className='pt-6 pb-16 space-y-6' data-id='reports-page'>
			<ReportsPage />
		</PageLayout>
	)
}
